// Generated by CoffeeScript 2.7.0
var Form;

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import RichTextEditor from 'trunks/vue/admin/components/libs/richtext_editor.js';

import FieldList from 'trunks/vue/admin/components/fields/list/fieldable.js';

import FormableMixin from 'trunks/vue/admin/compositions/formables/mixin.js';

import {
  newMessageSettingsModal
} from 'trunks/vue/admin/compositions/message_settings.js';

export default Form = Vue.extend({
  mixins: [FormableMixin],
  components: {
    editor: RichTextEditor,
    'field-list': FieldList
  },
  props: {
    resource: {
      type: String,
      default: '/admin/forms'
    },
    type: {
      type: String,
      default: 'form'
    }
  },
  data: function() {
    return {
      pagerenderable: false
    };
  },
  template: `<div class="formable-edit-view">
  <div class="formable-base-content"
       :class="{ 'with-page-tip': pagerenderable }">
    <div class="formable-title">
      <input type="text" placeholder='消息标题' v-model.trim='form.title' />
    </div>
    <div class="formable-description">
      <editor ref='editor' :value='form.description' placeholder='消息正文' scrollingContainer='main>.main-content' @valueChanged='editorTextChange' />
    </div>
  </div>
  <field-list :fields='form.fields'
              ref='fieldsView'
              :fieldable='form'
              @fieldLengthChanged='fieldsLengthChangedFunc'
              @pagerenderableChanged='pagerenderableChangedFunc' />
  <div class="attachments-container" v-show='attachments.length'>
    <attachments :files='attachments'
                 @removeItem='removeAttachment'
                 @reloadItem='reloadAttachment' />
  </div>
  <div class="formable-actions" ref='formableActions'>
    <div class="slp-tooltip right" data-title="添加表项">
      <div class="action-item clickable" @click='addNewField'>
        <i class="slp-plus-circle"></i>
      </div>
    </div>
    <div class="slp-tooltip right" data-title="添加章节">
      <div class="action-item clickable" @click='addSectionBreak'>
        <i class="slp-text-square"></i>
      </div>
    </div>
    <div class="slp-tooltip right" data-title="添加附件">
      <label class="action-item clickable">
        <input type="file" multiple='true' hidden='true' @change='addAttachments' />
        <i class="slp-attachment"></i>
      </label>
    </div>
    <div class="slp-tooltip right" data-title="添加分页">
      <div class="action-item clickable" @click='addPage'>
        <i class="slp-two-lines"></i>
      </div>
    </div>
  </div>
</div>`,
  mounted: function() {
    return this.pagerenderable = this.$refs.fieldsView.pagerenderable;
  },
  methods: {
    addNewField: function() {
      return this.$refs.fieldsView.addNewField();
    },
    fieldsLengthChangedFunc: function() {
      return this.$emit('fieldsLengthChanged');
    },
    pagerenderableChangedFunc: function(pagerenderable) {
      return this.pagerenderable = pagerenderable;
    },
    addSectionBreak: function() {
      return this.$refs.fieldsView.addNewField('Field::SectionBreak');
    },
    addPage: function() {
      return this.$refs.fieldsView.addNewField('Field::Page');
    },
    updateFields: function() {
      var has_blank_page;
      has_blank_page = this.$refs.fieldsView.checkBlankPage();
      if (has_blank_page) {
        return newAlertify('存在分页内容为空', {
          type: 'error'
        });
      } else {
        return Skylark.Libs.Ajax.patch(`/admin/forms/${this.form.id}`, {
          data: {
            form: this.getData().form
          },
          contentType: "application/json; charset=UTF-8",
          success: (form) => {
            this.form = new Skylark.App.Model.Form(form);
            return newAlertify('保存成功', {
              type: 'success'
            });
          }
        });
      }
    },
    updateFormSettings: function(settings) {
      var form_settings;
      form_settings = _.reduce(settings, function(memo, value, key) {
        var ref, ref1;
        switch (key) {
          case 'pushSetting':
            memo.user_boundary = value.user_boundary;
            memo.push_agent_on_publish_attributes = {
              include_uncompleted: true,
              push_package_id: (ref = value.push_agent) != null ? ref.push_package_id : void 0,
              scheduled_at: (ref1 = value.push_agent) != null ? ref1.scheduled_at : void 0
            };
            break;
          case 'tagsNamecardSetting':
            memo.tag_ids = value.tag_ids;
            break;
          case 'userFillSetting':
            _.extend(memo, value);
            delete memo.responses_sharing;
            if (memo.settings == null) {
              memo.settings = {};
            }
            memo.settings.responses_sharing = value.responses_sharing;
            break;
          case 'closeSetting':
          case 'afterSubmitSetting':
          case 'commentSetting':
            _.extend(memo, value);
            break;
          case 'redpacketSetting':
            if (!_.isEmpty(value)) {
              memo.red_packet_setting = value;
            }
            break;
          case 'releaseSetting':
            memo.published_as_id = value.organization_id;
            memo.namecard_id = value.namecard_id;
            break;
          case 'tableMapperSetting':
            memo.settings.table_mapping = value;
        }
        return memo;
      }, {});
      return _.extend(this.form, form_settings);
    },
    updateDescription: function(description) {
      return this.form.description = description;
    },
    getData: function() {
      return {
        form: this.form.toJSON()
      };
    },
    preview: function() {
      return Skylark.Libs.Ajax['post']('/admin/forms/preview_version', {
        data: this.getData(),
        contentType: "application/json; charset=UTF-8",
        success: function(data, status, xhr) {
          return window.open(Skylark.Helpers.UrlHelper.namespaceUrlFor(`/messages/preview?key=${data.key}`));
        },
        error: function(xhr, status) {
          return newAlertify('预览失败', {
            type: 'error'
          });
        }
      });
    },
    validateFields: function() {
      var base, errors;
      if (this.form.fields.length < 1) {
        if ((base = this.errors).field == null) {
          base.field = [];
        }
        this.errors.field.push('不能为空');
      }
      errors = this.$refs.fieldsView.validate();
      return this.erros = _.extend(this.errors, errors);
    },
    openSaveConfirm: function() {
      var error_message, settings_modal;
      error_message = this.parseErrors();
      if (error_message) {
        newAlertify(error_messages, {
          type: 'error'
        });
        return;
      }
      settings_modal = newMessageSettingsModal(this.form, {
        type: 'form'
      });
      return settings_modal.$on('ensureClicked', (settings) => {
        var save_xhr;
        this.updateFormSettings(settings);
        save_xhr = this.save();
        if (!save_xhr) {
          return newAlertify('发布失败', {
            type: 'error'
          });
        }
      });
    },
    editorTextChange: function(value) {
      return this.updateDescription(value);
    },
    _validate: function() {
      this.validateTitle();
      this.validateFields();
      return this.validateBlankPage();
    }
  }
});
